import template from "./bSubHeader.html";

export function bSubHeaderDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    scope: {
      user: "=?",
      employee: "=?",
      teamLeader: "=?",
      manager: "=?",
      breadcrumb: "=?",
      overtime: "=?",
      customCloseHandler: "&?",
      disabled: "=?"
    },
    controller: bSubHeaderController,
    controllerAs: 'bSubHeader',
    bindToController: true
  };

  return directive;
}

class bSubHeaderController {
  constructor (Auth, IncomesAvailable, Stats, Bundle, OvertimeApplications, $interval, $location, $scope) {
    'ngInject';
    this.$interval = $interval;
    this.$location = $location;
    this.$scope = $scope;

    this.$onInit = () => {
      this.Auth = Auth;
      this.IncomesAvailable = IncomesAvailable;
      this.Stats = Stats;
      this.Bundle = Bundle;
      this.showProfitabilityWhenHasIncomesAvailable = true;
      this.is360visible = false;
      this.OvertimeApplications = OvertimeApplications;

      const userInfo = localStorage.getItem("ngStorage-roedl-session");
      const excludeFromProfitability = localStorage.getItem("exclude-from-profitability");

      this.userInfo = userInfo && angular.fromJson(userInfo);
      this.excludeFromProfitability = excludeFromProfitability && angular.fromJson(excludeFromProfitability);

      if(!this.userInfo) return;

      if(!this.userInfo.preferences || !this.userInfo.preferences.featureFlags) {
        this.Auth.setFeatureFlagsToLocaleStorage(this.userInfo).then( newUserInfo => {
          this.userInfo = newUserInfo;
          this.setBasicFeatureFlags();
        });
      } else {
        this.setBasicFeatureFlags();
        this.isPowerUser = this.userInfo.isPowerUser;
      }

      this.is360visible = this.view360FeatureFlag && this.userInfo.canAccess360View && this.profitabilityFeatureFlag;

      if(this.manager || this.teamLeader) {
        this.IncomesAvailable.checkIncomesAvailable().then(
          (incomesSuccess) => { // incomesSuccess.data = {hasIncomesAvailable: true/false}
            if(incomesSuccess.data.hasIncomesAvailable) this.showProfitabilityWhenHasIncomesAvailable = true;
          },
          () => {
            this.state = "error";
          }
        );
      }

      if(this.teamLeader) {
        this.Stats.getSubordinateTeams().then(
          (subordinateTeams) => {
            if(this.userInfo.teamId == "49a6dcff-c4e6-443e-9627-597070a68c8e") { // team iterators
              this.excludeFromProfitability = false;
            } else {
              let subTeam = subordinateTeams.data.find( team => team.id == this.userInfo.teamId);
              this.excludeFromProfitability = subTeam && subTeam.excludeFromProfitabilityReport;
            }
            localStorage.setItem("exclude-from-profitability", this.excludeFromProfitability);
          }
        );

      }


      if (!this.$location.path().includes('overtimeRequest') && this.overtimeApplicationsFlag) {
        this.getOvertimeApplicationsNotificationInfo();
        this.overtimeApplicationsNotificationInterval = this.$interval(() => this.getOvertimeApplicationsNotificationInfo(), 60000);
      }
    };

    this.$scope.$on("$destroy", () => {this.$interval.cancel(this.overtimeApplicationsNotificationInterval);});
  }

  setBasicFeatureFlags() {
    this.powerUserFeatureFlag     = this.userInfo.preferences.featureFlags.find(f => f == "PowerUser");
    this.overtimeFeatureFlag      = this.userInfo.preferences.featureFlags.find(f => f == "OvertimeManagement");
    this.profitabilityFeatureFlag = this.userInfo.preferences.featureFlags.find(f => f == "ProfitabilityView");
    this.view360FeatureFlag       = this.userInfo.preferences.featureFlags.find(f => f == "View360");
    this.FlexiFeatureFlag         = this.userInfo.preferences.featureFlags.find(f => f == "Flexitime");
    this.acceptanceHierarchy      = this.userInfo.preferences.featureFlags.find(f => f === "AcceptanceHierarchy");
    this.overtimeApplicationsFlag     = this.userInfo.preferences.featureFlags.find(f => f === "OvertimeApplications");
  }

  bundleBusinessEnterpriseRoedl(){
    return ['roedl', 'business', 'enterprise'].includes(this.Bundle.getBundleType());
  }

  back() {
    if (this.customCloseHandler)
      this.customCloseHandler();
    else
      window.close();
  }

  isProfitabilityAvailable() {
    return (
      this.showProfitabilityWhenHasIncomesAvailable &&
      this.profitabilityFeatureFlag &&
      (typeof this.excludeFromProfitability === 'boolean' && !this.excludeFromProfitability) &&
      this.bundleBusinessEnterpriseRoedl()
    );
  }

  sumObjectValuesAsNumber(obj) {
    return Object.entries(obj).reduce((prev, curr) => (
      prev + (
        typeof curr[1] !== 'number'
          ? this.sumObjectValuesAsNumber(curr[1])
          : this.userInfo.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' && curr[0] === '49a6dcff-c4e6-443e-9627-597070a68c8e'
          ? 0
          : curr[1]
      )
    ), 0);
  }

  getOvertimeApplicationsNotificationInfo() {
    const viewType = this.$location.path().includes('/stats/me')
      ? 'Employee'
      : this.$location.path().includes('/stats/team')
      ? 'Team'
      : 'Management';

    this.OvertimeApplications.getApplications(viewType === 'Employee', viewType).then(
      (success) => {
        this.overtimeApplicationsNotification = viewType !== 'Management'
          ? (viewType === 'Employee' ? success.data : success.data.applicationsViews).filter(application => (
              application.userId === this.userInfo.id
              && viewType === 'Employee'
                ? (['New', 'UpdateDone'].includes(application.status) && !application.employeeAccepted)
                : ['ToAccept', 'RequestedUpdate'].includes(application.status)
            )).length
          : this.sumObjectValuesAsNumber(success.data.applicationViewLevelStatus);
      }
    ).catch(() => {});
  }
}
